module.exports = __webpack_public_path__ + "img/logo.f958a881.png";